import { Setter } from "../../services/ComService"
import { parseStringFromServer } from "../../services/TextConverter"

interface IUserItem {
  userId: number
  userEmail: string
  userName: string
}

interface IUserFkt extends IUserItem {
  id: number
  fkt: number
}

interface ICustomerItem {
  id: number
  name: string
  fkts: IUserFkt[]
}

export class UserCustomerMatrixDTO {
  userId?: number
  customerId?: number
  fkt?: number
  limit: number = 1000
  page: number = 0
  customers: ICustomerItem[] = []
  users: IUserItem[] = []

  async getFromServer() {
    const data = await Setter('userCustomerFkt', {
      userId: this.userId,
      customerId: this.customerId,
      fkt: this.fkt,
      limit: this.limit,
      page: this.page
    }) as {customers: ICustomerItem[]}
    this.customers = data.customers.map((c) => {
      return {
        ...c,
        name: parseStringFromServer(c.name),
      }
    })
    // Get involved users:
    let users: IUserItem[] = []
    this.customers.forEach((c) => {
      c.fkts.forEach((f) => {
        if (!users.some((u) => u.userId === f.userId)) {
          users.push(f)
        }
      })
    })
    this.users = users
    return data
  }
  userInCustomer(userId: number, customerId: number) {
    return this.customers.find(c => c.id === customerId)?.fkts.some(f => f.userId === userId)
  }
}
